import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'invoice-search-dialog',
    templateUrl: './invoice-search-dialog.component.html',
    providers: [DataService] //force as a local provider
})
export class InvoiceSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    //Override Method: called to construct initialize the search component
    initialize(): boolean {
        this.parentActiveModal = this.activeModal;

        this.objectType = 'DBQuery';
        this.model.criteria.Procedure_Name = 'epx_tempopeninvoicesearch';
        this.model.title = 'Select Invoice';

        this.model.criteria.Book_Entity_ID = 'CURRENTBOOK';
        this.model.criteria.Max = this.model.currentOptions.maxRows;

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
